export default {
  methods: {
    setLanguageFilter (value, type, filterByLanguage) {
      const index = filterByLanguage.indexOf(type)
      if (value && index === -1) {
        filterByLanguage.push(type)
      } else if (index !== -1) {
        filterByLanguage.splice(index, 1)
      }
      const lang = filterByLanguage.map(item => `client.languages[]=${item}`).join('&')
      return lang
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setLanguageFilter.js